export default __webpack_public_path__ + "static/media/engineRed.20765450.svg";